// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3pHN9","selected":"Chip_selected__2e4sL"};